module.exports = __webpack_public_path__ + "static/media/workers.55242156.jpg";